import React, { useEffect, useState } from "react";
import "./Admin.css"; // Import CSS
import axios from "axios";
import { baseurl } from "./CoocpeatHome";
import { useNavigate } from "react-router-dom";

function AdminDashBoard() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");


    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("admin_token");

        if (token) {
            navigate("/admin/home");
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(baseurl + "admin/AdminLogin", {
                email: username,
                password: password,
            });

            const token = response.data.token;

            if (token) {
                // Store token
                localStorage.setItem("admin_token", token);
                navigate("/admin/home");
            }
        } catch (error) {
            alert("Call Homee For Admin Register");
        }
    };

    return (
        <div className="admin-container">
            <div className="login-card">
                <h2 className="login-title">Administrator Login</h2>
                <form onSubmit={handleLogin}>
                    <label>Username</label>
                    <div className="input-box">
                        <span className="icon">👤</span>
                        <input
                            type="text"
                            placeholder="admin"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <label>Password</label>
                    <div className="input-box">
                        <span className="icon">🔒</span>
                        <input
                            type="password"
                            placeholder="•••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button className="login-btn" type="submit">
                        LOG IN
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AdminDashBoard;
